import io from "socket.io-client";
export const getInstance = () => {
  const config = spat.config.websocket;
  return io(config.endpoint, {
    path: config.path,
    // websocket に限定したい場合は指定する
    // transports: ['websocket'],
  });
};

export const onEndRaffleEvent = (raffle_event_id, callback) => {
  const socket = getInstance();

  socket.on('notify_raffle_event_result', (arg) => {
    callback(arg);
    socket.disconnect();
  });

  socket.on('connect', () => {
    socket.emit('subscribe_raffle_event', raffle_event_id);
  });

  return socket;
};

export default {
  getInstance,
  onEndRaffleEvent,
};